import gql from "graphql-tag";

export const EDIT_HUMAN_VERIFIED_HOTEL = gql`
  mutation editHumanVerifiedHotel($id: ID!, $wontDo: Boolean, $verified: Boolean, $bestMatch: String) {
   editHumanVerifiedHotel(id: $id, wontDo: $wontDo, verified: $verified, bestMatch: $bestMatch) {
      id
    }
  }
`;
